import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function NewSZLTView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const application_order_service_new = currentApplication?.application_order_service_new || {};
  const registry_subject = currentApplication?.registry_subject || {};
  const files = currentApplication?.files || [];

  const {
    order_receiving_methods,
    web_site,
  } = application_order_service_new;

  const {
    order_receiving_methods: old_order_receiving_methods,
    web_site: old_web_site,
  } = registry_subject;

  const order_receiving_methods_change_document = files.find(item => item.collection_name === 'order_receiving_methods_change_document');
  const web_site_change_document = files.find(item => item.collection_name === 'web_site_change_document');

  const hasOrderReceivingMethods = !!order_receiving_methods || order_receiving_methods === null || order_receiving_methods_change_document;
  const hasWebSite = !!web_site || web_site === null || web_site_change_document;

  if (![PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменились сведения о СЗЛТ</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOrderReceivingMethods,
            }}
            label="Изменились способы получения и передачи заказов ЛТ"
          />
        </Col>
      </Row>
      {hasOrderReceivingMethods && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.order_receiving_methods',
              old_order_receiving_methods,
              null,
              'application_order_service_new.order_receiving_methods',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.order_receiving_methods',
              order_receiving_methods,
              fieldsValidation,
              'application_order_service_new.order_receiving_methods',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.order_receiving_methods_change_document',
              order_receiving_methods_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[order_receiving_methods_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasWebSite,
            }}
            label="Изменился адрес сайта ИТС 'Интернет'"
          />
        </Col>
      </Row>
      {hasWebSite && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.web_site',
              old_web_site,
              null,
              'application_order_service_new.web_site',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.web_site',
              web_site,
              fieldsValidation,
              'application_order_service_new.web_site',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.web_site_change_document',
              web_site_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[web_site_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
